<template>
<div class="row p-1 mt-3 bg-white">
    <div class="row p-2">
        <div class="col" style="margin-left: 30px;">
            <a-dropdown>
                <template #overlay>
                    <a-menu @click="updateQueryDuration">
                        <a-menu-item key="LastThreeMonth">
                            <CalendarTwoTone />&nbsp;三個月內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastSixMonth">
                            <CalendarTwoTone />&nbsp;六個月內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastYear">
                            <CalendarTwoTone />&nbsp;一年內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastTwoYear">
                            <CalendarTwoTone />&nbsp;兩年內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="AllYears">
                            <CalendarTwoTone />&nbsp;所有已新增之專案
                        </a-menu-item>
                    </a-menu>
                </template>
                <a-button>
                    <CalendarTwoTone />{{ ProjectQueryDurationNames.get(reportForm.queryDuration) }}&nbsp;<DownOutlined />
                </a-button>
            </a-dropdown>
        </div>
    </div>
    <div class="row p-1 mt-3">
      <div class="col">
        <a-spin :spinning="isloading" size="large">
          <a-table 
              :columns="columns" 
              :data-source="reportForm.data" 
              :pagination="reportForm.paginateConfig" 
              :expandedRowKeys="reportForm.expandedRows"
              @expand="expandProject" 
              @change="changeDataPage">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'projectNo'">
                <div class="hyperlink" @click="expandOnClickProject(record)">
                  {{ record.projectNo }}
                </div>
              </template>
              <template v-if="column.key === 'projectStatus'">
                <span>
                  <a-tag :color="ProjectStatusColors.get(record.projectStatus)">
                    <template #icon v-if="record.projectStatus === 'COMPLETED'">
                      <CheckCircleOutlined />
                    </template>
                    <template #icon v-else-if="record.projectStatus === 'PROCESSING'">
                      <SyncOutlined />
                    </template>
                    <template #icon v-else-if="record.projectStatus === 'WAIT_PROCESS'">
                      <ClockCircleOutlined />
                    </template>
                    <template #icon v-else-if="record.projectStatus === 'VOID'">
                      <MinusCircleOutlined />
                    </template>
                    {{ ProjectStatusNames.get(record.projectStatus) }}
                  </a-tag>
                </span>
              </template>
              <template v-else-if="column.key === 'expireDateStart'">
                <CalendarOutlined />&nbsp;&nbsp;{{ record.expireDateStart }}
              </template>
              <template v-else-if="column.key === 'expireDateEnd'">
                <CalendarOutlined />&nbsp;&nbsp;{{ record.expireDateEnd }}
              </template>
              <template v-else-if="column.key === 'action'">
                <a-dropdown :trigger="['click']">
                  <template #overlay>
                    <a-menu>
                      <a-menu-item key="1" @click="performDownloadAction(record)">
                        <DownloadOutlined />&nbsp;下載未匯入人員&nbsp;(.xlsx)
                      </a-menu-item>
                      <a-menu-item key="2">
                        <a-upload :multiple="false" :showUploadList="false" 
                          :beforeUpload="saveToUploadFile" @change="performUploadAction(record)">
                          <UploadOutlined />&nbsp;匯入人員名單
                      </a-upload>
                      </a-menu-item>
                      
                    </a-menu>
                  </template>
                  <a-button>
                    更多 <DownOutlined />
                  </a-button>
                </a-dropdown>
              </template>
            </template>
            <template #expandedRowRender="{ record }">
              <a-table :columns="innerColumns" 
                  :data-source="record.projectDetails" >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'questTypes'">
                    <span>
                      <a-tag v-for="questType in record.questTypes"
                        :key="questType"
                        :color="QuestTypeColors.get(questType)">
                        {{ QuestTypeNames.get(questType) }}
                      </a-tag>
                    </span>
                  </template>
                </template>
              </a-table>
            </template>
          </a-table>
        </a-spin>
      </div>
    </div>
</div>
</template>
<script setup>
import { CalendarTwoTone, DownOutlined, CalendarOutlined, DownloadOutlined, 
    UploadOutlined, ExclamationCircleOutlined, MinusCircleOutlined, ClockCircleOutlined, 
    SyncOutlined, CheckCircleOutlined } from "@ant-design/icons-vue";
import { ProjectQueryDurationNames, ProjectStatusColors, ProjectStatusNames, 
    QuestTypeColors, QuestTypeNames } from "@/common";
import { ref, reactive, onMounted } from "vue";

import { message } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import { createVNode, h } from 'vue';

import config from "@/config";
import common from "@/common";

const reportForm = reactive({});
const isloading = ref(false);

const columns = [{
    title: '專案編號',
    dataIndex: 'projectNo',
    key: 'projectNo',
    width: '150px'
}, {
    title: '專案名稱',
    dataIndex: 'projectName',
    key: 'projectName',
}, {
    title: '客戶名稱',
    dataIndex: 'compName',
    key: 'compName',
}, {
    title: '專案狀態',
    key: 'projectStatus',
    dataIndex: 'projectStatus',
    align: "center",
    width: '100px'
}, {
    title: '問卷開始日期',
    dataIndex: 'expireDateStart',
    key: 'expireDateStart',
    align: "center",
    width: '130px'
}, {
    title: '問卷結束日期',
    dataIndex: 'expireDateEnd',
    key: 'expireDateEnd',
    align: "center",
    width: '130px'
}, {
    title: '未匯入人數',
    key: 'numberOfUnImport',
    dataIndex: 'numberOfUnImport',
    align: "right",
    width: '120px'
}, {
    title: '動作',
    key: 'action',
    align: "center",
    width: '90px'
}];

const innerColumns = [{
    title: '證件編號',
    dataIndex: 'personalNo',
    key: 'personalNo',
    width: '120px'
}, {
    title: '已填寫問卷種類',
    dataIndex: 'questTypes',
    key: 'questTypes'
}];

const expandProject = (expanded, record) => {
    record.projectDetails = [];
    if (expanded) {
        reportForm.expandedRows.push(record.key);
        isloading.value = true;
        common.getRequest(config.projectUnImportMembers + record.key, (response) => {
            console.log("[Project-UnImport] Get UnImport Members by Project Url: " + record.key);
            isloading.value = false;
            record.projectDetails = response.data;
        }, () => isloading.value = false);
    } else {
        const keyIndex = reportForm.expandedRows.indexOf(record.key);
        if (keyIndex > -1) {
            reportForm.expandedRows.splice(keyIndex, 1);
        }
    }
}

const expandOnClickProject = (record) => {
    const keyIndex = reportForm.expandedRows.indexOf(record.key);
    expandProject(keyIndex < 0, record);
}

const changeDataPage = (page) => {
    reportForm.paginateConfig.current = page.current;
    reportForm.paginateConfig.pageSize = page.pageSize;
}

const updateQueryDuration = (menuItem) => {
    if (reportForm.queryDuration === menuItem.key) {
        return ;
    }
    reportForm.queryDuration = menuItem.key;
    common.saveQueryDuration(reportForm.queryDuration);
    reloadData();
}

const getApiRequestBody = () => {
    return {
        duration: reportForm.queryDuration
    };
}

const reloadData = () => {
    if (isloading.value) {
        return;
    }
    reportForm.expandedRows = [];
    reportForm.uploadFile = null;
    isloading.value = true;
    common.postRequest(config.projectUnImportList, getApiRequestBody(), (response) => {
        isloading.value = false;
        console.log("[Project-UnImport] Get UnImport Data by QueryDuration: " + reportForm.queryDuration);
        reportForm.data = response.data;
        reportForm.paginateConfig.current = 1;
    }, () => isloading.value = false);
}

const performDownloadAction = (record) => {
    console.log("[Project-UnImport] Download XLSX with record key: " + record.key);
    common.downloadFile(config.projectUnImportDownloadXlsx + record.key, record.projectNo + "-未匯入清單.xlsx");
}

const saveToUploadFile = (uploadFile) => {
    if (uploadFile.name.endsWith('.xls') || uploadFile.name.endsWith('.xlsx')) {
        reportForm.uploadFile = uploadFile;
    } else {
        reportForm.uploadFile = null;
        const modalWidth = common.getTextLength(uploadFile.name) * 8 + 280;
        Modal.error({
            title: "上傳失敗",
            centered: true,
            width: modalWidth + "px",
            content: h(
            'div',
            { style: 'white-space: pre;' },
            "你所上傳的檔案格式有誤 [" + uploadFile.name + "]\n只接受 XLS 或 XLSX 格式的檔案！"
            )
        });
    }
    return false;
}

const getConfirmMessage = (projectRecord) => {
    return "是否確認從檔案 [" + reportForm.uploadFile.name + "] 匯入至以下專案\n" + 
        "專案編號：" + projectRecord.projectNo + "\n" + 
        "專案名稱：" + projectRecord.projectName + "\n" + 
        "客戶名稱：" + projectRecord.compName;
}

const confirmUpload = (record, confirmAction) => {
    const modalWidth = common.getTextLength(reportForm.uploadFile.name) * 8 + 300;
    Modal.confirm({
        title: '匯入確認',
        centered: true,
        width: modalWidth + "px",
        icon: createVNode(ExclamationCircleOutlined),
        content: h(
          'div',
          { style: 'white-space: pre;' },
          getConfirmMessage(record)
        ),
        async onOk() {
          return await new Promise((resolve) => {
            setTimeout(resolve, 1500);
          })
          .then(confirmAction);
        },
        onCancel() {},
    });
}

const executeUploadAction = (record) => {
    console.log("[Project-UnImport] Upload XLS/XLSX by record key: " + record.key + " and File: " + reportForm.uploadFile.name);
    const formData = new FormData();
    formData.append('projectUrl', record.key);
    formData.append('file', reportForm.uploadFile);

    isloading.value = true;
    common.postFormDataRequest(config.importProjectUser, formData, (response) => {
        console.log("[Project-UnImport] Import ProjectUser successfully with result: " + response)
        message.success("匯入成功。", 3)
        isloading.value = false;
        reloadData();
    }, (error) => {
        console.log("[Project-UnImport] Import ProjectUser failed with error: " + error);
        Modal.error({
            title: "匯入失敗",
            centered: true,
            width: "600px",
            content: "匯入人員清單時發生錯誤「" + error.response.data + "」"
        });
        isloading.value = false;
    });
}

const performUploadAction = (record) => {
    if (reportForm.uploadFile == null) {
        return ;
    }
    confirmUpload(record, () => executeUploadAction(record));
}

onMounted(() => {
    reportForm.queryDuration = common.getQueryDuration("LastThreeMonth");
    reportForm.data = [];
    reportForm.paginateConfig = { };
    reportForm.expandedRows = [];
    reportForm.uploadFile = null;
    reloadData();
});
</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
.hyperlink {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}
</style>
